import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { InfoBoxBase } from './info-box-base';

@Component({
  selector: 'app-info-box-renewal',
  imports: [FontAwesomeModule],
  templateUrl: './info-box-renewal.html',
  styleUrl: './info-box-shared.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoBoxRenewal extends InfoBoxBase {
}
